import { LocaleMessages } from 'vue-i18n';

export class I18nState {
  public locale = process.env.VUE_APP_I18N_LOCALE || 'pt';
  public messages: LocaleMessages = {};
  public fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt';
}

export const state: I18nState = new I18nState();
